(function() {

	"use strict";

	angular.module( "ATMGurus" )

	.directive( "videoLinks", [
		"$compile",
		function( $compile ) {

			return {
				restrict: "EA",
				scope: {
					items: '&'
				},
				link: function( scope, element, attrs ) {


					/**
					*
					*	build up video menu content
					*
					*/
					var ul = angular.element( "<ul></ul>").addClass( "list-bare");
					var list = [];

					angular.forEach( scope.items(), function( item, key )  {
						var icon = angular.element( '<svg class="icon-play-circle icon-left icon-md"><use xlink:href="#play-circle"></use></svg>' );
						var li = angular.element( "<li></li>" )
							.addClass( 'mb1' );

						var a = angular.element( "<a class='media media-h'></a>")
							.attr( 'ng-click', 'playVideo( "' + item.video_title + '", "' + item.video_link + '")' )
							.append(
								angular.element( '<div></div>' )
								.append( icon )
								.addClass( 'media-visual' )
								.addClass( 'mrs' )
							)
							.append(
								angular.element( '<div></div>' )
								.addClass( 'media-body' )
								.text( item.video_title)
							)

						li.append( a )
						this.push( li )
					}, list )

					ul.append( list );
					element.html( $compile( ul )( scope ) );
				},
				controller: [ "$scope", '$element', function( $scope, $element ) {

					$scope.playVideo = function( title, id ) {
						$scope.$emit( "modal.open", {
							title: title,
							template: 'video_player',
							data: { video_id: id }
						} );
					}

				} ],
			}
		}
	] )
})()

/*
*
*	Final structure
*
<li class="mb1">
	<a class="media media-h" ng-click="playVideo( title, id)">
		<div class="media-visual mrs"><svg class="icon-play-circle icon-left icon-md"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#play-circle"></use></svg></div>
		<div class="media-body">Nils Frahm Boiler Room</div>
	</a>
</li>
*/


// WEBPACK FOOTER //
// ./src/app/directives/videoLinks.js